var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.className,attrs:{"fill":"none","height":_vm.height,"viewBox":"0 0 2 8","width":_vm.width,"xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"fill":_vm.fill,"height":"5","rx":"1","width":"2","y":"3"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"1","cy":"1","fill":_vm.fill,"r":"1"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }